import { FAB } from '@elotech/components';
import React from 'react';

interface Props {
  desabilitado: boolean;
  onSalvar: () => void;
  onLimpar?: () => void;
}

const AcoesFormularios: React.FC<Props> = ({
  desabilitado,
  onSalvar,
  onLimpar
}) => (
  <div className="btn-save">
    {!!onLimpar && (
      <FAB
        icon="broom"
        iconColor="white"
        title="Limpar"
        typeButton={'bg-red-50' as any}
        disabled={desabilitado}
        onClick={onLimpar}
      />
    )}
    <FAB
      icon="save"
      iconColor="white"
      title="Salvar"
      disabled={desabilitado}
      onClick={onSalvar}
    />
  </div>
);

export default AcoesFormularios;
